import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SolanaWalletData } from '../../models/solana-wallet.model';
import { AdminService } from '../../services/admin.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-solana-wallet-card',
  standalone: false,
  templateUrl: './solana-wallet-card.component.html',
  styleUrl: './solana-wallet-card.component.css',
})
export class SolanaWalletCardComponent implements OnInit {
  @Input() wallet!: SolanaWalletData;
  @Output() openTransfer = new EventEmitter<void>();

  constructor(
    private adminService: AdminService,
    private authService: AuthService,
  ) {}

  get isWalletsManager(): boolean {
    return this.authService.isWalletsManager();
  }

  onTransferClick(event: Event): void {
    event.stopPropagation();
    this.openTransfer.emit();
  }

  ngOnInit(): void {
    this.fetchBalance();
  }

  get isBelowThreshold(): boolean {
    return (
      this.wallet.balance !== null &&
      this.wallet.balance < this.wallet.config.threshold
    );
  }

  copied = false;

  get shortAddress(): string {
    const addr = this.wallet.config.address;
    if (addr.length <= 12) return addr;
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  }

  copyAddress(): void {
    navigator.clipboard.writeText(this.wallet.config.address).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

  refresh(): void {
    this.fetchBalance(true);
  }

  private fetchBalance(forceRefresh: boolean = false): void {
    if (this.wallet.config.provider === 'PRIVY') {
      this.fetchPrivyBalance(forceRefresh);
      return;
    }
    this.wallet.loading = true;
    this.wallet.error = null;
    this.adminService
      .getWalletBalance(this.wallet.config.address, forceRefresh)
      .subscribe({
        next: (res) => {
          this.wallet.balance = res.amount;
          this.wallet.loading = false;
        },
        error: () => {
          this.wallet.error = 'Failed to load balance';
          this.wallet.loading = false;
        },
      });
  }

  private fetchPrivyBalance(forceRefresh: boolean): void {
    // The Privy endpoint returns zeros for an unknown ID instead of an error.
    if (!this.wallet.config.walletId) {
      this.wallet.error = 'Missing Privy wallet ID';
      return;
    }
    this.wallet.loading = true;
    this.wallet.error = null;
    this.adminService
      .getPrivyWalletBalance(this.wallet.config.walletId, forceRefresh)
      .subscribe({
        next: (res) => {
          this.wallet.balance = res.USDC;
          this.wallet.eurcBalance = res.EURC;
          this.wallet.loading = false;
        },
        error: () => {
          this.wallet.error = 'Failed to load balance';
          this.wallet.loading = false;
        },
      });
  }
}
